import { isArray, isDefined } from '../../../utils/isDefined';

const mapConnections = connections => {
  if (!isArray(connections) || connections.length === 0) {
    return [];
  }

  const slaConnections = connections
    .filter(connection => connection.commercialProduct?.sku?.startsWith('SLA'))
    .filter(
      connection => connection.subscriptionAgreement?.status === 'ACTIVE'
    );
  const nonSlaConnections = connections.filter(
    connection => !connection.commercialProduct?.sku?.startsWith('SLA')
  );

  const mapConnection = connection => {
    const { fromDate, status, account } = connection.subscriptionAgreement;
    return {
      ...connection.subscription,
      id: connection.id,
      commercialProduct: connection.commercialProduct?.category,
      technicalProduct: connection.technicalProduct?.category,
      user: connection.accountUser?.name,
      accountName: `${connection.subscription?.account?.name} - ${connection.subscription?.account?.accountNo}`,
      activationDate: fromDate,
      agreementStatus: status,
      account
    };
  };

  const mappedConnections = nonSlaConnections
    .map(connection => {
      const mappedConnection = mapConnection(connection);

      const matchingSlaConnections = slaConnections.filter(
        slaConnection =>
          slaConnection.accountUser?.externalReference ===
          connection.accountUser?.externalReference
      );

      if (matchingSlaConnections.length > 0) {
        mappedConnection.subproducts = matchingSlaConnections.map(
          slaConnection => ({
            ...slaConnection.subscription,
            activationDate: slaConnection.subscriptionAgreement?.fromDate
          })
        );
      }

      return mappedConnection;
    })
    .filter(
      connection =>
        isDefined(connection.commercialProduct) &&
        connection.agreementStatus === 'ACTIVE'
    );

  return mappedConnections;
};

export default mapConnections;
